export default __webpack_public_path__ + "static/media/drippingblood.ff47066a.png";